import { helpDialog } from "./dialog-configs";

export const MS_PER_SECOND = 1000;

export const SESSION_EVENTS = {
	ITEM_VIEWED: "item_viewed",
	CHOICE_CROSSED_OUT: "choice_crossed_out",
	CHOICES_UNSELECTED: "choices_unselected",
	CHOICES_SELECTED: "choices_selected",
	ANSWER_SUBMITTED: "answer_submitted",
	HINT_REQUESTED: "hint_requested",
	TEXT_HIGHLIGHTED: "text_highlighted",
	ITEM_MARKED_FOR_REVIEW: "item_marked_for_review",
} as const;

export const IS_MOCKED_SESSION = false;

// Render above the bottom app bar + some padding
export const FAB_BOTTOM_POSITION = 80 + 24;

//TODO: Move this to the backend session response
const studyResourcesLink: Record<string, { links: string[] }> = {
	// Water Distribution Operator Class I
	"bc6e3975-d58a-464f-ac64-49e7f51f1a51": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/WaterDistribution-%E2%80%93-Class-1.pdf)",
			"[WPI Formula Conversion Tables](https://gowpi.org/wp-content/uploads/2024/05/WPI-FCT-2024-WT.pdf)",
		],
	},

	// Water Distribution Operator Class II
	"57e08ae4-711e-4a08-b803-bd01b76f1b5e": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/WaterDistribution-%E2%80%93-Class-2.pdf)",
			"[WPI Formula Conversion Tables](https://gowpi.org/wp-content/uploads/2024/05/WPI-FCT-2024-WT.pdf)",
		],
	},

	// Water Treatment Operator Class I
	"921bbcce-51a2-4f38-abcd-39af1bff6138": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/Water-Treatment-Class-1.pdf)",
			"[WPI Formula Conversion Tables](https://gowpi.org/wp-content/uploads/2024/05/WPI-FCT-2024-WT.pdf)",
		],
	},

	// Water Treatment Operator Class II
	"05d27078-4e22-4d1f-9a10-b5cf35f0f780": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/Water-Treatment-Class-2.pdf)",
			"[WPI Formula Conversion Tables](https://gowpi.org/wp-content/uploads/2024/05/WPI-FCT-2024-WT.pdf)",
		],
	},

	// Wastewater Collection Operator Class I
	"f827ea60-2940-427d-8b38-e12ba2971ec4": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/Collection-%E2%80%93-Class-1.pdf)",
			"[WPI Formula Conversion Tables](https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/WWT-FCT_081023_with-Pie-Wheels.pdf)",
		],
	},

	// Wastewater Collection Operator Class II
	"653b3c9d-a9e0-4ffa-9478-ff8d6a6c7864": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/Collection-%E2%80%93-Class-2.pdf)",
			"[WPI Formula Conversion Tables](https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/WWT-FCT_081023_with-Pie-Wheels.pdf)",
		],
	},

	// Wastewater Treatment Operator Class I
	"dd3fa17a-0eec-4f29-bbe9-58d68470e8fe": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/WastewaterTreatment-%E2%80%93-Class-1.pdf)",
			"[WPI Formula Conversion Tables](https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/WWT-FCT_081023_with-Pie-Wheels.pdf)",
		],
	},

	// Wastewater Treatment Operator Class II
	"019e3490-882c-4f2a-a273-f672559d5ab3": {
		links: [
			"[Need-to-Know Document](https://gowpi.org/wp-content/uploads/2025/06/WastewaterTreatment-%E2%80%93-Class-2.pdf)",
			"[WPI Formula Conversion Tables](https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/WWT-FCT_081023_with-Pie-Wheels.pdf)",
		],
	},
};

export { helpDialog, studyResourcesLink };
